var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section7-container",attrs:{"data-aos":"fade-in"}},[_c('part4'),_c('part6',{staticClass:"section7-container-part6"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }